import { EntityBase } from "./entity-base.model";

export class MisSetUp extends EntityBase {
  public SystemName: string;
  public KeyValue: string;
  public DataValue: string;
}
